const makeConstant = constant => `knowledgebase/${constant}`

export const SET_DOCUMENT = makeConstant('SET_DOCUMENT')
export const SET_TITLE = makeConstant('SET_TITLE')
export const SET_SLUG = makeConstant('SET_SLUG')
export const SET_STATUS = makeConstant('SET_STATUS')

export const CLEAR_ARTICLE_ERRORS = makeConstant('CLEAR_ARTICLE_ERRORS')

export const CHECK_TITLE = makeConstant('CHECK_TITLE')
export const CHECK_TITLE_SUCCESS = makeConstant('CHECK_SUCCESS')
export const CHECK_TITLE_FAILED = makeConstant('CHECK_FAILED')

export const CHECK_SLUG = makeConstant('CHECK_SLUG')
export const CHECK_SLUG_SUCCESS = makeConstant('CHECK_SLUG_SUCCESS')
export const CHECK_SLUG_FAILED = makeConstant('CHECK_SLUG_FAILED')

export const SET_ARTICLE = makeConstant('SET_ARTICLE')
export const CLEAR_ARTICLE = makeConstant('CLEAR_ARTICLE')

export const CREATE_ARTICLE = makeConstant('CREATE_ARTICLE')
export const CREATE_ARTICLE_PENDING = makeConstant('CREATE_ARTICLE_PENDING')
export const CREATE_ARTICLE_SUCCESS = makeConstant('CREATE_ARTICLE_SUCCESS')
export const CREATE_ARTICLE_FAILED = makeConstant('CREATE_ARTICLE_FAILED')

export const DELETE_ARTICLE = makeConstant('DELETE_ARTICLE')
export const DELETE_ARTICLE_PENDING = makeConstant('DELETE_ARTICLE_PENDING')
export const DELETE_ARTICLE_SUCCESS = makeConstant('DELETE_ARTICLE_SUCCESS')
export const DELETE_ARTICLE_FAILED = makeConstant('DELETE_ARTICLE_FAILED')

export const SET_ARTICLE_CATEGORY = makeConstant('SET_ARTICLE_CATEGORY')
export const SET_ARTICLE_SECTION = makeConstant('SET_ARTICLE_SECTION')

export const CREATE_CATEGORY = makeConstant('CREATE_CATEGORY')
export const CREATE_CATEGORY_PENDING = makeConstant('CREATE_CATEGORY_PENDING')
export const CREATE_CATEGORY_SUCCESS = makeConstant('CREATE_CATEGORY_SUCCESS')
export const CREATE_CATEGORY_FAILED = makeConstant('CREATE_CATEGORY_FAILED')

export const EDIT_CATEGORY = makeConstant('EDIT_CATEGORY')
export const EDIT_CATEGORY_PENDING = makeConstant('EDIT_CATEGORY_PENDING')
export const EDIT_CATEGORY_SUCCESS = makeConstant('EDIT_CATEGORY_SUCCESS')
export const EDIT_CATEGORY_FAILED = makeConstant('EDIT_CATEGORY_FAILED')

export const DELETE_CATEGORY = makeConstant('DELETE_CATEGORY')
export const DELETE_CATEGORY_PENDING = makeConstant('DELETE_CATEGORY_PENDING')
export const DELETE_CATEGORY_SUCCESS = makeConstant('DELETE_CATEGORY_SUCCESS')
export const DELETE_CATEGORY_FAILED = makeConstant('DELETE_CATEGORY_FAILED')

export const CHANGE_CATEGORY_NAME = makeConstant('CHANGE_CATEGORY_NAME')
export const CHANGE_CATEGORY_DESCRIPTION = makeConstant('CHANGE_CATEGORY_DESCRIPTION')

export const EDIT_ARTICLE = makeConstant('EDIT_ARTICLE')
export const EDIT_ARTICLE_PENDING = makeConstant('EDIT_ARTICLE_PENDING')
export const EDIT_ARTICLE_SUCCESS = makeConstant('EDIT_ARTICLE_SUCCESS')
export const EDIT_ARTICLE_FAILED = makeConstant('EDIT_ARTICLE_FAILED')

export const FETCH_ARTICLE = makeConstant('FETCH_ARTICLE')
export const FETCH_ARTICLE_PENDING = makeConstant('FETCH_ARTICLE_PENDING')
export const FETCH_ARTICLE_SUCCESS = makeConstant('FETCH_ARTICLE_SUCCESS')
export const FETCH_ARTICLE_FAILED = makeConstant('FETCH_ARTICLE_FAILED')

export const FETCH_CATEGORIES = makeConstant('FETCH_CATEGORIES')
export const FETCH_CATEGORIES_PENDING = makeConstant('FETCH_CATEGORIES_PENDING')
export const FETCH_CATEGORIES_SUCCESS = makeConstant('FETCH_CATEGORIES_SUCCESS')
export const FETCH_CATEGORIES_FAILED = makeConstant('FETCH_CATEGORIES_FAILED')

export const CHANGE_SECTION_NAME = makeConstant('CHANGE_SECTION_NAME')
export const CHANGE_SECTION_DESCRIPTION = makeConstant('CHANGE_SECTION_DESCRIPTION')
export const CHANGE_SECTION_CATEGORY = makeConstant('CHANGE_SECTION_CATEGORY')

export const SAVE_SECTION_EDITS = makeConstant('SAVE_SECTION_EDITS')
export const SAVE_SECTION_EDITS_PENDING = makeConstant('SAVE_SECTION_EDITS_PENDING')
export const SAVE_SECTION_EDITS_SUCCESS = makeConstant('SAVE_SECTION_EDITS_SUCCESS')
export const SAVE_SECTION_EDITS_FAILED = makeConstant('SAVE_SECTION_EDITS_FAILED')

export const SET_SECTION_TO_EDIT = makeConstant('SET_SECTION_TO_EDIT')
export const CLEAR_SECTION_TO_EDIT = makeConstant('CLEAR_SECTION_TO_EDIT')

export const SET_CATEGORY = makeConstant('SET_CATEGORY')
export const CLEAR_CATEGORY = makeConstant('CLEAR_CATEGORY')

export const CREATE_SECTION = makeConstant('CREATE_SECTION')
export const CREATE_SECTION_PENDING = makeConstant('CREATE_SECTION_PENDING')
export const CREATE_SECTION_SUCCESS = makeConstant('CREATE_SECTION_SUCCESS')
export const CREATE_SECTION_FAILED = makeConstant('CREATE_SECTION_FAILED')

export const DELETE_SECTION = makeConstant('DELETE_SECTION_EDITS')
export const DELETE_SECTION_PENDING = makeConstant('DELETE_SECTION_PENDING')
export const DELETE_SECTION_SUCCESS = makeConstant('DELETE_SECTION_SUCCESS')
export const DELETE_SECTION_FAILED = makeConstant('DELETE_SECTION_FAILED')

export const SET_SECTION_TO_DELETE = makeConstant('SET_SECTION_TO_DELETE')
export const CLEAR_SECTION_TO_DELETE = makeConstant('CLEAR_SECTION_TO_DELETE')

export const REORDER_CATEGORIES = makeConstant('REORDER_CATEGORIES')
export const REORDER_CATEGORIES_PENDING = makeConstant('REORDER_CATEGORIES_PENDING')
export const REORDER_CATEGORIES_SUCCESS = makeConstant('REORDER_CATEGORIES_SUCCESS')
export const REORDER_CATEGORIES_FAILED = makeConstant('REORDER_CATEGORIES_FAILED')

export const REORDER_CATEGORY_DOCUMENTS = makeConstant('REORDER_CATEGORY_DOCUMENTS')
export const REORDER_CATEGORY_DOCUMENTS_PENDING = makeConstant('REORDER_CATEGORY_DOCUMENTS_PENDING')
export const REORDER_CATEGORY_DOCUMENTS_SUCCESS = makeConstant('REORDER_CATEGORY_DOCUMENTS_SUCCESS')
export const REORDER_CATEGORY_DOCUMENTS_FAILED = makeConstant('REORDER_CATEGORY_DOCUMENTS_FAILED')

export const REORDER_CATEGORY_SECTIONS = makeConstant('REORDER_CATEGORY_SECTIONS')
export const REORDER_CATEGORY_SECTIONS_PENDING = makeConstant('REORDER_CATEGORY_SECTIONS_PENDING')
export const REORDER_CATEGORY_SECTIONS_SUCCESS = makeConstant('REORDER_CATEGORY_SECTIONS_SUCCESS')
export const REORDER_CATEGORY_SECTIONS_FAILED = makeConstant('REORDER_CATEGORY_SECTIONS_FAILED')

export const REORDER_SECTION_DOCUMENTS = makeConstant('REORDER_SECTION_DOCUMENTS')
export const REORDER_SECTION_DOCUMENTS_PENDING = makeConstant('REORDER_SECTION_DOCUMENTS_PENDING')
export const REORDER_SECTION_DOCUMENTS_SUCCESS = makeConstant('REORDER_SECTION_DOCUMENTS_SUCCESS')
export const REORDER_SECTION_DOCUMENTS_FAILED = makeConstant('REORDER_SECTION_DOCUMENTS_FAILED')